/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';

export type BbDocsSubmitPartialUpdateRequest = {} | null | undefined;
export type BbDocsSubmitPartialUpdateResponse = any;

export type BbDocsSubmitPartialUpdateQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this doc.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * PATCH /dmx-server/bb_docs/{id}/submit/
 *
 * ```yaml
 * operationId: bb_docs_submit_partial_update
 * tags:
 *   - bb_docs
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     description: No response body
 * ```
 */
export const bbDocsSubmitPartialUpdateOperation = ({
  id,
  ...rest
}: BbDocsSubmitPartialUpdateQuery) =>
  ({
    method: 'PATCH',
    path: `/dmx-server/bb_docs/${id}/submit/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'PATCH';
    path: string & { _templateUrl: '/dmx-server/bb_docs/{id}/submit/' };
  };

/**
 * PATCH /dmx-server/bb_docs/{id}/submit/
 *
 * ```yaml
 * operationId: bb_docs_submit_partial_update
 * tags:
 *   - bb_docs
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     description: No response body
 * ```
 */
export const bbDocsSubmitPartialUpdate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: BbDocsSubmitPartialUpdateQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<any>> => {
  const operation = bbDocsSubmitPartialUpdateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'PATCH',
    request,
    onUploadProgress,
    cancelToken,
  );
};
